(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpf-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpf-collection-offer')) {
    customElements.define('dpf-collection-offer', class extends HTMLElement {
      connectedCallback() {
        const remaining = Date.parse(this.dataset.expires) - Date.now();
        if (remaining <= 0) { this.expire(); return; }
        if (remaining < 2147483647) this.expiryTimer = setTimeout(() => this.expire(), remaining + 1000);
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
      expire() {
        if (this.dataset.kind === 'banner') { this.remove(); return; }
        this.querySelector('[data-was]').hidden = true;
        this.querySelector('[data-sale]').hidden = true;
        this.querySelector('[data-regular]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpf-home-universe"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpf-print-offer')) {
    customElements.define('dpf-print-offer', class extends HTMLElement {
      connectedCallback() {
        const remaining = Date.parse(this.dataset.expires) - Date.now();
        if (remaining <= 0) { this.remove(); return; }
        if (remaining < 2147483647) this.expiryTimer = setTimeout(() => this.remove(), remaining + 1000);
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpf-product-atmosphere"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!document.querySelector('.dpf-product-atmosphere')) return;
    const protectPreview = (event) => {
      if (event.target.closest('.product__media, .product-media-modal__content')) {
        event.preventDefault();
      }
    };
    document.addEventListener('contextmenu', protectPreview);
    document.addEventListener('dragstart', protectPreview);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpf-site-atmosphere"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const atmosphere = document.querySelector('.dpf-site-atmosphere');
    if (!atmosphere) return;
    const selectors = [
      '.dpf-collection-card__image',
      '.dpf-home-galaxy__image',
      '.dpf-gallery-card__media',
      '.card__media .media',
      '.cart-item__image-container',
      '.collection-hero__image-container',
      '.banner__media',
      '.image-with-text__media',
      '.slideshow__media',
      '.collage-card__image-wrapper'
    ].join(',');
    const protectMedia = () => {
      document.querySelectorAll(selectors).forEach((media) => {
        if (!media.querySelector('img')) return;
        if (media.closest('.header, .footer')) return;
        media.classList.add('dpf-protected-media');
      });
    };
    const protectPreview = (event) => {
      if (event.target.closest('.dpf-protected-media')) event.preventDefault();
    };
    document.addEventListener('contextmenu', protectPreview);
    document.addEventListener('dragstart', protectPreview);
    protectMedia();
    new MutationObserver(protectMedia).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('dpf-format-picker')) {
    customElements.define('dpf-format-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.select = this.querySelector('[data-dpf-select]');
        const requested = location.hash.replace('#dpf-format-', '').toLowerCase();
        const option = Array.from(this.select.options).find(option => option.dataset.format === requested);
        if (option) this.select.value = option.value;
        this.select.addEventListener('change', () => { this.update(); history.replaceState(null, '', '#dpf-format-' + this.select.selectedOptions[0].dataset.format); });
        this.update();
        const remaining = Date.parse(this.dataset.offerEnd) - Date.now();
        if (remaining > 0 && remaining < 2147483647) this.offerTimer = setTimeout(() => this.update(), remaining + 1000);
      }
      disconnectedCallback() { clearTimeout(this.offerTimer); }
      update() {
        const option = this.select.selectedOptions[0];
        const digital = option.dataset.format === 'digital';
        const offerActive = Date.now() < Date.parse(this.dataset.offerEnd);
        const sale = !digital && offerActive && option.dataset.salePrice;
        const original = this.querySelector('[data-dpf-original-price]');
        original.hidden = !sale;
        original.textContent = sale ? option.dataset.price : '';
        this.querySelector('[data-dpf-price]').textContent = sale ? option.dataset.salePrice : option.dataset.price;
        const offer = this.querySelector('[data-dpf-offer]');
        if (offer) offer.hidden = !offerActive;
        if (!offerActive) Array.from(this.select.options).forEach(item => {
          if (item.dataset.salePrice) item.textContent = item.dataset.format.toUpperCase() + ' unframed print — ' + item.dataset.price;
        });
        this.querySelector('[data-dpf-note]').textContent = digital
          ? 'Digital download · Personal-use licence · No physical item or postage'
          : option.dataset.format.toUpperCase() + ' unframed print · Individually hand-printed · Certificate of authenticity included · Dispatch within one working day · UK Royal Mail Tracked 48 with signature: £5 per order';
        const template = this.querySelector(digital ? '[data-dpf-digital]' : '[data-dpf-print]');
        this.querySelector('[data-dpf-description]').replaceChildren(template.content.cloneNode(true));
        const button = this.querySelector('button[name="add"]');
        button.disabled = option.dataset.available !== 'true';
        button.removeAttribute('aria-disabled');
        this.querySelector('.sold-out-message').classList.add('hidden');
        this.querySelector('[data-dpf-add-label]').classList.remove('hidden');
        this.querySelector('[data-dpf-add-label]').textContent = button.disabled ? 'Sold out' : 'Add to cart';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
